import * as english from './english.json';
import * as sidebarmenu from './sidebarmenu.json';
import * as forgotPassword from './forgotpassword.json';
import * as setPassword from './setPassword.json';
import * as onboarding from './onboarding.json';
import * as users from './users.json';
import * as regulations from './regulations.json';
import * as task from './task.json';
import * as dashboard from './dashboard.json';
import * as setting from './setting.json';
import * as newsFeeds from './newsFeeds.json';
import * as fines from './fines.json';
import * as averyAiChatBot from './averyAiChatBot.json';
import * as reports from './reports.json';
import * as mydoc from './mydoc.json';
import * as adminRegulation from './adminRegulation.json';

const allEn = {
  english,
  sidebarmenu,
  forgotPassword,
  setPassword,
  onboarding,
  users,
  regulations,
  task,
  dashboard,
  setting,
  newsFeeds,
  averyAiChatBot,
  reports,
  fines,
  mydoc,
  adminRegulation
};

export default allEn;
